import Layout from './modules/Layout.js';

new Layout('article-page');
